module.exports = __webpack_public_path__ + "img/3.a75cf669.jpg";